// EBITDA Waterfall Data
// UPDATED: Now using REAL DATA from ABC Excel files
// Source: ABC_Demonstracao_Resultados.xlsx

// Import real financial data
import { 
  realIncomeStatementData,
  toMillionsUSD 
} from './realFinancialData';

// ============================================================================
// EBITDA WATERFALL DATA - FROM REAL DATA
// ============================================================================
export const ebitdaWaterfallData = {
  // 2024 ACTUAL - FROM REAL DATA
  2024: [
    { name: { pt: "Vendas", en: "Sales" }, value: toMillionsUSD(realIncomeStatementData[2024].vendas), type: "income" },  // 93.79 M USD
    { name: { pt: "Outros Proveitos", en: "Other Income" }, value: toMillionsUSD(realIncomeStatementData[2024].outrosProveitos), type: "income" },  // 0.21 M USD
    { name: { pt: "Variação PA e PVF", en: "WIP & Finished Goods Variation" }, value: toMillionsUSD(realIncomeStatementData[2024].variacaoPAePVF), type: realIncomeStatementData[2024].variacaoPAePVF >= 0 ? "income" : "cost" },  // -2.90 M USD (NEW)
    { name: { pt: "CMVMC", en: "COGS" }, value: toMillionsUSD(realIncomeStatementData[2024].cmvmc), type: "cost" },  // -12.02 M USD
    { name: { pt: "Subcontratos", en: "Subcontracts" }, value: toMillionsUSD(realIncomeStatementData[2024].subcontratos), type: "cost" },  // -6.38 M USD
    { name: { pt: "Gerais e Administrativos", en: "General & Administrative" }, value: toMillionsUSD(realIncomeStatementData[2024].geraisAdministrativos), type: "cost" },  // -6.73 M USD
    { name: { pt: "Custos de Comercialização", en: "Commercial Costs" }, value: toMillionsUSD(realIncomeStatementData[2024].custosComercializacao), type: "cost" },  // -60.47 M USD
    { name: { pt: "Custos com Pessoal", en: "Personnel Costs" }, value: toMillionsUSD(realIncomeStatementData[2024].custosPessoal), type: "cost" },  // -32.99 M USD
    { name: { pt: "EBITDA", en: "EBITDA" }, value: toMillionsUSD(realIncomeStatementData[2024].ebitda), type: "total" },  // 30.63 M USD
  ],
  // 2025 BUDGET - FROM REAL DATA
  2025: [
    { name: { pt: "Vendas", en: "Sales" }, value: toMillionsUSD(realIncomeStatementData[2025].vendas), type: "income" },  // 104.25 M USD
    { name: { pt: "Outros Proveitos", en: "Other Income" }, value: toMillionsUSD(realIncomeStatementData[2025].outrosProveitos), type: "income" },  // 0.49 M USD
    { name: { pt: "Variação PA e PVF", en: "WIP & Finished Goods Variation" }, value: toMillionsUSD(realIncomeStatementData[2025].variacaoPAePVF), type: realIncomeStatementData[2025].variacaoPAePVF >= 0 ? "income" : "cost" },  // 0.71 M USD (NEW)
    { name: { pt: "CMVMC", en: "COGS" }, value: toMillionsUSD(realIncomeStatementData[2025].cmvmc), type: "cost" },  // -19.23 M USD
    { name: { pt: "Subcontratos", en: "Subcontracts" }, value: toMillionsUSD(realIncomeStatementData[2025].subcontratos), type: "cost" },  // -4.91 M USD
    { name: { pt: "Gerais e Administrativos", en: "General & Administrative" }, value: toMillionsUSD(realIncomeStatementData[2025].geraisAdministrativos), type: "cost" },  // -7.61 M USD
    { name: { pt: "Custos de Comercialização", en: "Commercial Costs" }, value: toMillionsUSD(realIncomeStatementData[2025].custosComercializacao), type: "cost" },  // -72.57 M USD
    { name: { pt: "Custos com Pessoal", en: "Personnel Costs" }, value: toMillionsUSD(realIncomeStatementData[2025].custosPessoal), type: "cost" },  // -37.92 M USD
    { name: { pt: "EBITDA", en: "EBITDA" }, value: toMillionsUSD(realIncomeStatementData[2025].ebitda), type: "total" },  // 32.88 M USD
  ],
  // 2026 BUDGET - FROM REAL DATA
  2026: [
    { name: { pt: "Vendas", en: "Sales" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.vendas), type: "income" },  // 131.92 M USD
    { name: { pt: "Outros Proveitos", en: "Other Income" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.outrosProveitos), type: "income" },  // 1.31 M USD
    { name: { pt: "Variação PA e PVF", en: "WIP & Finished Goods Variation" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.variacaoPAePVF), type: realIncomeStatementData[2026].annual.variacaoPAePVF >= 0 ? "income" : "cost" },  // 1.34 M USD (NEW)
    { name: { pt: "CMVMC", en: "COGS" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.cmvmc), type: "cost" },  // -23.81 M USD
    { name: { pt: "Subcontratos", en: "Subcontracts" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.subcontratos), type: "cost" },  // -7.19 M USD
    { name: { pt: "Gerais e Administrativos", en: "General & Administrative" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.geraisAdministrativos), type: "cost" },  // -9.31 M USD
    { name: { pt: "Custos de Comercialização", en: "Commercial Costs" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.custosComercializacao), type: "cost" },  // -83.02 M USD
    { name: { pt: "Custos com Pessoal", en: "Personnel Costs" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.custosPessoal), type: "cost" },  // -41.61 M USD
    { name: { pt: "EBITDA", en: "EBITDA" }, value: toMillionsUSD(realIncomeStatementData[2026].annual.ebitda), type: "total" },  // 51.55 M USD
  ],
};

// ============================================================================
// COST BREAKDOWN BY CATEGORY - FROM REAL DATA
// ============================================================================
export const costBreakdownData = {
  // 2024 ACTUAL
  2024: {
    materials: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2024].cmvmc)), 
      percentage: Math.abs(realIncomeStatementData[2024].cmvmc) / Math.abs(realIncomeStatementData[2024].totalCustosOperacionais) * 100,
      yoyChange: 0  // No prior year for comparison
    },
    personnel: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2024].custosPessoal)), 
      percentage: Math.abs(realIncomeStatementData[2024].custosPessoal) / Math.abs(realIncomeStatementData[2024].totalCustosOperacionais) * 100,
      yoyChange: 0
    },
    services: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2024].geraisAdministrativos)), 
      percentage: Math.abs(realIncomeStatementData[2024].geraisAdministrativos) / Math.abs(realIncomeStatementData[2024].totalCustosOperacionais) * 100,
      yoyChange: 0
    },
    subcontracts: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2024].subcontratos)), 
      percentage: Math.abs(realIncomeStatementData[2024].subcontratos) / Math.abs(realIncomeStatementData[2024].totalCustosOperacionais) * 100,
      yoyChange: 0
    },
    commercial: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2024].custosComercializacao)), 
      percentage: Math.abs(realIncomeStatementData[2024].custosComercializacao) / Math.abs(realIncomeStatementData[2024].totalCustosOperacionais) * 100,
      yoyChange: 0
    },
    total: toMillionsUSD(Math.abs(realIncomeStatementData[2024].totalCustosOperacionais)),
  },
  // 2025 BUDGET
  2025: {
    materials: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2025].cmvmc)), 
      percentage: Math.abs(realIncomeStatementData[2025].cmvmc) / Math.abs(realIncomeStatementData[2025].totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2025].cmvmc - realIncomeStatementData[2024].cmvmc) / Math.abs(realIncomeStatementData[2024].cmvmc)) * 100
    },
    personnel: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2025].custosPessoal)), 
      percentage: Math.abs(realIncomeStatementData[2025].custosPessoal) / Math.abs(realIncomeStatementData[2025].totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2025].custosPessoal - realIncomeStatementData[2024].custosPessoal) / Math.abs(realIncomeStatementData[2024].custosPessoal)) * 100
    },
    services: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2025].geraisAdministrativos)), 
      percentage: Math.abs(realIncomeStatementData[2025].geraisAdministrativos) / Math.abs(realIncomeStatementData[2025].totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2025].geraisAdministrativos - realIncomeStatementData[2024].geraisAdministrativos) / Math.abs(realIncomeStatementData[2024].geraisAdministrativos)) * 100
    },
    subcontracts: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2025].subcontratos)), 
      percentage: Math.abs(realIncomeStatementData[2025].subcontratos) / Math.abs(realIncomeStatementData[2025].totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2025].subcontratos - realIncomeStatementData[2024].subcontratos) / Math.abs(realIncomeStatementData[2024].subcontratos)) * 100
    },
    commercial: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2025].custosComercializacao)), 
      percentage: Math.abs(realIncomeStatementData[2025].custosComercializacao) / Math.abs(realIncomeStatementData[2025].totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2025].custosComercializacao - realIncomeStatementData[2024].custosComercializacao) / Math.abs(realIncomeStatementData[2024].custosComercializacao)) * 100
    },
    total: toMillionsUSD(Math.abs(realIncomeStatementData[2025].totalCustosOperacionais)),
  },
  // 2026 BUDGET
  2026: {
    materials: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2026].annual.cmvmc)), 
      percentage: Math.abs(realIncomeStatementData[2026].annual.cmvmc) / Math.abs(realIncomeStatementData[2026].annual.totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2026].annual.cmvmc - realIncomeStatementData[2025].cmvmc) / Math.abs(realIncomeStatementData[2025].cmvmc)) * 100
    },
    personnel: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2026].annual.custosPessoal)), 
      percentage: Math.abs(realIncomeStatementData[2026].annual.custosPessoal) / Math.abs(realIncomeStatementData[2026].annual.totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2026].annual.custosPessoal - realIncomeStatementData[2025].custosPessoal) / Math.abs(realIncomeStatementData[2025].custosPessoal)) * 100
    },
    services: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2026].annual.geraisAdministrativos)), 
      percentage: Math.abs(realIncomeStatementData[2026].annual.geraisAdministrativos) / Math.abs(realIncomeStatementData[2026].annual.totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2026].annual.geraisAdministrativos - realIncomeStatementData[2025].geraisAdministrativos) / Math.abs(realIncomeStatementData[2025].geraisAdministrativos)) * 100
    },
    subcontracts: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2026].annual.subcontratos)), 
      percentage: Math.abs(realIncomeStatementData[2026].annual.subcontratos) / Math.abs(realIncomeStatementData[2026].annual.totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2026].annual.subcontratos - realIncomeStatementData[2025].subcontratos) / Math.abs(realIncomeStatementData[2025].subcontratos)) * 100
    },
    commercial: { 
      value: toMillionsUSD(Math.abs(realIncomeStatementData[2026].annual.custosComercializacao)), 
      percentage: Math.abs(realIncomeStatementData[2026].annual.custosComercializacao) / Math.abs(realIncomeStatementData[2026].annual.totalCustosOperacionais) * 100,
      yoyChange: ((realIncomeStatementData[2026].annual.custosComercializacao - realIncomeStatementData[2025].custosComercializacao) / Math.abs(realIncomeStatementData[2025].custosComercializacao)) * 100
    },
    total: toMillionsUSD(Math.abs(realIncomeStatementData[2026].annual.totalCustosOperacionais)),
  },
};

// EBITDA Margin Trend
export const ebitdaMarginTrendData = {
  2024: [
    { month: 'Jan', margin: 30.2, revenue: 19.5, ebitda: 5.9 },
    { month: 'Feb', margin: 31.5, revenue: 20.8, ebitda: 6.6 },
    { month: 'Mar', margin: 33.1, revenue: 22.1, ebitda: 7.3 },
    { month: 'Apr', margin: 32.4, revenue: 21.2, ebitda: 6.9 },
    { month: 'May', margin: 31.8, revenue: 19.8, ebitda: 6.3 },
    { month: 'Jun', margin: 32.9, revenue: 22.3, ebitda: 7.3 },
    { month: 'Jul', margin: 31.2, revenue: 21.0, ebitda: 6.6 },
    { month: 'Aug', margin: 30.5, revenue: 20.5, ebitda: 6.3 },
    { month: 'Sep', margin: 31.1, revenue: 19.8, ebitda: 6.2 },
    { month: 'Oct', margin: 32.3, revenue: 21.2, ebitda: 6.8 },
    { month: 'Nov', margin: 31.7, revenue: 20.2, ebitda: 6.4 },
    { month: 'Dec', margin: 32.0, revenue: 20.4, ebitda: 6.5 },
  ],
  2025: [
    { month: 'Jan', margin: 32.8, revenue: 22.8, ebitda: 7.5 },
    { month: 'Feb', margin: 33.5, revenue: 23.5, ebitda: 7.9 },
    { month: 'Mar', margin: 35.2, revenue: 26.1, ebitda: 9.2 },
    { month: 'Apr', margin: 34.6, revenue: 25.0, ebitda: 8.7 },
    { month: 'May', margin: 33.9, revenue: 24.2, ebitda: 8.2 },
    { month: 'Jun', margin: 35.1, revenue: 27.1, ebitda: 9.5 },
    { month: 'Jul', margin: 34.2, revenue: 25.5, ebitda: 8.7 },
    { month: 'Aug', margin: 33.6, revenue: 24.8, ebitda: 8.3 },
    { month: 'Sep', margin: 34.0, revenue: 24.2, ebitda: 8.2 },
    { month: 'Oct', margin: 34.8, revenue: 25.8, ebitda: 9.0 },
    { month: 'Nov', margin: 34.3, revenue: 24.6, ebitda: 8.4 },
    { month: 'Dec', margin: 34.5, revenue: 24.5, ebitda: 8.5 },
  ],
  2026: [
    { month: 'Jan', margin: 36.2, revenue: 25.2, ebitda: 9.1 },
    { month: 'Feb', margin: 36.8, revenue: 26.1, ebitda: 9.6 },
    { month: 'Mar', margin: 38.5, revenue: 29.4, ebitda: 11.3 },
    { month: 'Apr', margin: 37.8, revenue: 27.2, ebitda: 10.3 },
    { month: 'May', margin: 37.2, revenue: 26.5, ebitda: 9.9 },
    { month: 'Jun', margin: 38.8, revenue: 30.2, ebitda: 11.7 },
    { month: 'Jul', margin: 37.5, revenue: 27.8, ebitda: 10.4 },
    { month: 'Aug', margin: 36.9, revenue: 26.7, ebitda: 9.9 },
    { month: 'Sep', margin: 37.3, revenue: 26.2, ebitda: 9.8 },
    { month: 'Oct', margin: 38.1, revenue: 27.9, ebitda: 10.6 },
    { month: 'Nov', margin: 37.6, revenue: 26.6, ebitda: 10.0 },
    { month: 'Dec', margin: 27.8, revenue: 14.0, ebitda: 3.9 },
  ],
};
